import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { isValid, parse } from "date-fns";

export default function ReferredDate({ initValue, onChange }) {
  
  let parsedValue = null;

  if (initValue) {
    const temp = parse(initValue, "yyyy-MM-dd", new Date());
    parsedValue = isValid(temp) ? temp : null;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label="Referral Date"
        defaultValue={parsedValue ?? new Date()}
        onChange={(value) => {
          onChange("referredAt", value);
        }}
      />
    </LocalizationProvider>
  );
}
